<template>
    <div>
        <v-offline online-class="online" offline-class="offline" @detected-condition="amIOnline">
            <template v-slot:[onlineSlot] :slot-name="onlineSlot">
                {{ onlineOfflineMsg }}
            </template>
            <template v-slot:[offlineSlot] :slot-name="offlineSlot">
                {{ onlineOfflineMsg }}
            </template>
        </v-offline>

        <el-drawer title="Add Field Team" :visible.sync="showDrawer" size="30%" direction="rtl" @closed="handleClose">
            <div class="manage-section">
                <div class="form-group">
                    <fg-input type="text" ref="addFieldTeamName" label="Field Team Name*" name="Field Team Name"
                        v-validate="fieldTeamValidation.fieldTeamName" :error="getError('Field Team Name')"
                        v-model="model.fieldTeamName">
                    </fg-input>
                </div>
                <div class="form-group">
                    <label class="control-label">Field Team Description</label>
                    <textarea class="form-control" v-model="model.fieldTeamDescription"
                        placeholder="Enter description here..." rows="3"></textarea>
                </div>
                <div class="text-right mt-3">
                    <el-button
                        v-if="onLine"
                        class=""
                        :loading="actionLoading"
                        v-on:click="validateAndSubmit"
                        type="primary"
                        round>
                        Add Field Team
                    </el-button>
                </div>
            </div>
        </el-drawer>
    </div>
</template>

<script>

import mixin from '../../mixins/GlobalMixin';
import VOffline from 'v-offline';
import { mapGetters } from 'vuex';

import { Drawer, Button } from 'element-ui';

export default {
    components: {
        [Drawer.name]: Drawer,
        [Button.name]: Button,
        VOffline
    },
    props: {
        showFtForm: {
            type: Boolean,
        }
    },
    data() {
        return {
            showDrawer: false,
            model: {
                fieldTeamName: '',
                fieldTeamDescription: '',
                selectedOrganisation: null,
            },
            fieldTeamValidation: {
                fieldTeamName: {
                    required: true,
                }
            },
            teams: [],
            actionLoading: false,
        }
    },
    mixins: [mixin],
    methods: {
        async init() {
            let vm = this;
            const project = vm.$store.getters.getCurrentSelectedProject;
            this.showDrawer = this.showFtForm;
            this.model.selectedOrganisation = project.organisation_id
        },
        validateAndSubmit: function () {
            let vm = this;
            this.$refs.addFieldTeamName.$validator.validate('Field Team Name').then((result) => {
                vm.actionLoading = true;
                if (result) {
                    axios.post('/field_team/create', {
                        name: vm.model.fieldTeamName,
                        description: vm.model.fieldTeamDescription,
                        organisation_id: vm.model.selectedOrganisation,
                    }).then(response => {
                        if (response.data.response.error.error_code == 0) {
                            vm.handleClose();
                            this.$emit('fetchTeams');
                            vm.showAlert('Success', response.data.response.error.msg, true);
                            vm.model.fieldTeamName = '';
                            vm.model.fieldTeamDescription = '';
                            vm.$validator.reset();
                        }
                    }).catch(error => {
                        if (error.response.status === 400) {
                            vm.showAlert('Error', error.response.data.response.error.error_msg, false);
                        } else {
                            console.log(error);
                        }
                    })
                        .finally(() => vm.actionLoading = false);
                }
                return false;
            }).catch(() => {
                return false
            })
        },
        getError: function getError(fieldName) {
            return this.errors.first(fieldName);
        },
        handleClose() {
            this.$emit('hideTeamForm');
        }
    },
    computed: {
        ...mapGetters('user', ['userOrganisations']),
    },
    mounted() {
        this.init();
    },
}

</script>

<style scoped>
.manage-section {
    padding: 20px;
    margin: 10px;
}

@media (max-width: 768px) {
    .manage-section {
        padding: 15px;
        border-radius: 15px;
        margin: 0 0 20px;
    }

    .manage-section h3 {
        font-size: 1.4em;
        margin-bottom: 15px;
    }
}
</style>
